import { Injectable } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { JOB_CURRENTLY_RESPONSIBLE_COUNT_KEY } from "@services/index";
import { UsersFilterGeneratorService } from "./users-filter-generator.service";
import { type OptionValue } from "@app/filter-menu/filter-types";

@Injectable()
export class JobsCurrentlyResponsibleFilterGeneratorService extends UsersFilterGeneratorService {
    protected override label: ITranslateObject = {
        "en-CA": "Currently Responsible",
        "fr-CA": "Responsable actuel",
    };

    protected override visibilityCountKey = JOB_CURRENTLY_RESPONSIBLE_COUNT_KEY;

    public override generateFilter(selectedValues: OptionValue[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            return (card: JobsBillingCard) => {
                const id = card.job.currentlyResponsible;
                return (id === null && selectedValues.includes("-1")) || selectedValues.includes(id);
            };
        }
    }
}
